import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from '@brighthub/environment';
import { enableProdMode } from '@angular/core';
import * as Sentry from '@sentry/angular';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: environment.sentry['dsn'],
  environment: environment.sentry['environment'],
  release: environment.appVersion,
  integrations: [
    Sentry.browserTracingIntegration({
      instrumentNavigation: true,
    }),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],

  tracesSampleRate: environment.production ? 0.1 : 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
Sentry.setTag('app', 'brighthub');
bootstrapApplication(AppComponent, appConfig).then(() => {
  Sentry.addBreadcrumb({
    category: 'system',
    message: 'BrightHub bootstrapped',
    level: 'info',
  });
  })
  .catch((err) => {
    Sentry.captureException(err);
    console.error(err);
  });
